var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WujieVue',{attrs:{"width":"100%","height":"100%","name":"vite","url":_vm.viteUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }